import { useEffect, useState } from "react";
import { axiosClient } from "../api/proxy/AxiosClient";
import Users from "./Users";
import { useServices } from "../services/ServiceContext";
import { Box, Modal } from "@mui/material";
import LessonPaymentsSummary from "./LessonPaymentsSummary";

export default function Students() {

  const user = JSON.parse(localStorage.getItem("user"));
  const [students, setStudents] = useState([]);
  const [lessons, setLessons] = useState([]);
  const [transactions, setTransactions] = useState([]);

  const [mode, setMode] = useState("empty");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedLessons, setSelectedLessons] = useState([]);
  const [selectedTxs, setSelectedTxs] = useState([]);
  const { lesson } = useServices();

  const [balanceModalOpen, setBalanceModalOpen] = useState(false);
  const handleOpenBalance = () => setBalanceModalOpen(true);
  const handleCloseBalance = () => setBalanceModalOpen(false);

  useEffect(() => {
    axiosClient
      .get("/teachers/students")
      .then((res) => setStudents(res.data))
      .catch((err) => console.error("Error fetching students", err));
    axiosClient
      .get(`/lessons?teacherUid=${user.uid}`)
      .then((res) => setLessons(res.data))
      .catch((err) => console.error("Error fetching lessons", err));
    axiosClient
      .get(`/payments/by-teacher/${user.uid}`)
      .then((res) => setTransactions(res.data))
      .catch((err) => console.error("Error fetching transactions", err));
  }, [user.uid]);

  useEffect(() => {
    if (selectedStudent) {
      setSelectedLessons(lessons.filter(l => l.students.some(s => s.uid === selectedStudent.uid)));
      setSelectedTxs(transactions.filter(tx => tx.debtor?.uid === selectedStudent.uid));
    } else {  
      setSelectedLessons([]);
      setSelectedTxs([]);
    }
  }, [selectedStudent, lessons, transactions]);

  const createStudent = async (payload) => {
    const { data: newStudent } = await axiosClient.post("/students/", payload);
    addStudent(newStudent);
  }

  const addStudent = async (student) => {
    await axiosClient.post(`teachers/${user.uid}/students/${student.uid}`);
    setStudents([...students, student]);
    setSelectedStudent(student);
    setMode("view");
  }

  const updateStudent = async (payload) => {
    const { data: updatedStudent } = await axiosClient.patch(`/students/${payload.uid}`, payload);
    setStudents(() =>
      students.map((s) => (s.uid === updatedStudent.uid ? updatedStudent : s))
    );
    setSelectedStudent(updatedStudent);
  }

  const actions = [
    {
      label: "New Lesson",
      color: "#006600", //green
      active: () => !user.isDemo && mode !== "create" && selectedStudent,
      handler: () => {
        lesson.openCreateLessonForTeacher([selectedStudent], students);
      },
    },
    // {
    //   label: "Add to Lesson",
    //   active: () => selectedStudent,
    //   handler: () => {
    //     console.log("Add to Lesson clicked:", selectedStudent);
    //   },
    // },
    {
      label: "Add Student",
      color: "#4B0082",// indigo
      active: () => !user.isDemo && !selectedStudent,
      handler: () => {
        console.log("Add Student clicked:");
        setMode("create");
        setSelectedStudent(null);
      },
    },
    {
      label: "View Balance",
      color: "#006600", //green
      active: () => !!selectedStudent,
      handler: () => {
        handleOpenBalance();
      },
    },
  ];

  return (
    <>
    <Users
      mode={mode}
      setMode={setMode}
      initialUsers={students}
      updateUser={updateStudent}
      selectedUser={selectedStudent}
      setSelectedUser={setSelectedStudent}
      actions={actions}
      createUser={createStudent}
      addUser={addStudent}
      selectOrAddMessage={'Select or Add Student'}
      isSuperuser={user.type === 'superuser'}
    />

     <Modal
       open={balanceModalOpen}
       onClose={handleCloseBalance}
       aria-labelledby="balance-modal-title"
       aria-describedby="balance-modal-description"
     >
       <Box
         sx={{
           position: "absolute", top: "50%", left: "50%",
           transform: "translate(-50%, -50%)",
           bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, minWidth: 500
         }}
       >
         <LessonPaymentsSummary
           lessons={selectedLessons}
           transactions={selectedTxs}
         />
       </Box>
     </Modal>
     </>
  );
}
